import getIn from 'transmute/getIn';
export const getAuth = getIn(['auth']);